export default "__VITE_ASSET__b73ed385__"